import gql from "graphql-tag";

export const MY_NEWS_GET_EDITORS_NAME = gql`
  query getEditorsName($contract: String, $locale: String) {
    getEditorsName(contract: $contract, locale: $locale)
  }
`;
